import '../globalLibrariesMinimal';

/**
 * This pack only registers components for the account registration page (/register/free)
 * */
import AccountRegistration from '@strava/account-registration-page-ui';
import ReactComponentMounter from '../utils/react-component-mounter';
import Microfrontend from '../apps/Microfrontend/Microfrontend';

ReactComponentMounter.register({ Microfrontend, AccountRegistration });
